module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "epg__channels"
  }, _vm._l((_vm.channels), function(c) {
    return _c('div', {
      class: [
        'epg__channel', {
          'epg__channel--expanded': c._isSelected
        }
      ],
      style: (("height:" + ((c._isSelected) ? _vm.defaultTimeSlotHeight+_vm.expandedSlotHeight : _vm.defaultTimeSlotHeight) + "px"))
    }, [_c('div', {
      staticClass: "epg__channel-image"
    }, [_c('img', {
      attrs: {
        "src": (_vm.images && _vm.images[c.id]) ? _vm.images[c.id] : _vm.emptyImageUrl,
        "alt": c.name
      }
    })])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00225d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Channels/Channels.vue
// module id = 230
// module chunks = 1